// extracted by mini-css-extract-plugin
export default {"container":"TotalOverviewPerPlatform_container__BCNLN","chartColumn":"TotalOverviewPerPlatform_chartColumn__45xDT","overviewColumn":"TotalOverviewPerPlatform_overviewColumn__LMrYV"};